(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-cart-drawer"]) return;
  try {
    
(function(){
  var SECTION='kd-cart-drawer';
  var ov=document.querySelector('[data-cartov]');
  var drawer=document.querySelector('[data-cartdrawer]');
  if(!drawer)return;
  var busy=false;

  function open(){ov.classList.add('is-open');drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');document.body.classList.add('kd-cart-locked');}
  function close(){ov.classList.remove('is-open');drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');document.body.classList.remove('kd-cart-locked');}
  function setCount(n){
    document.querySelectorAll('.kd-nav2-cart-count').forEach(function(b){b.textContent=n;if(n>0){b.removeAttribute('hidden');}else{b.setAttribute('hidden','');}});
  }
  function swap(html){
    var doc=new DOMParser().parseFromString(html,'text/html');
    var fresh=doc.querySelector('[data-cart-inner]');
    var cur=drawer.querySelector('[data-cart-inner]');
    if(fresh&&cur)cur.innerHTML=fresh.innerHTML;
  }
  function render(state){
    if(state&&state.sections&&state.sections[SECTION])swap(state.sections[SECTION]);
    if(state&&typeof state.item_count==='number')setCount(state.item_count);
  }
  var nativeFetch=window.fetch.bind(window);
  var OWN='X-KD-Cart';
  function post(url,body,json){
    var h=json?{'Content-Type':'application/json','Accept':'application/json'}:{'Accept':'application/json'};h[OWN]='1';
    return nativeFetch(url,{method:'POST',headers:h,body:body}).then(function(r){
      return r.json().catch(function(){return {};}).then(function(d){if(!r.ok){var e=new Error((d&&(d.description||d.message))||'Could not update cart');e.status=r.status;throw e;}return d;});
    });
  }
  var _pending={}, _timers={};
  function queueChange(key,qty,span){
    qty=Math.max(0,qty);
    if(span && qty>0){span.textContent=qty;}
    _pending[key]=qty;
    if(_timers[key])clearTimeout(_timers[key]);
    _timers[key]=setTimeout(function(){ _flush(key); },400);
  }
  function _flush(key){
    if(busy){ _timers[key]=setTimeout(function(){_flush(key);},150); return; }
    if(!(key in _pending))return;
    var q=_pending[key]; delete _pending[key]; delete _timers[key];
    change(key,q);
  }
  function change(key,qty){
    if(busy)return;busy=true;drawer.setAttribute('data-busy','');
    post('/cart/change.js',JSON.stringify({id:key,quantity:qty,sections:SECTION,sections_url:location.pathname}),true)
      .then(render).catch(function(){}).finally(function(){busy=false;drawer.removeAttribute('data-busy');});
  }
  // Re-read the real cart (drawer markup + count). Add responses are line items, not the cart,
  // so they never carry item_count; always finish an add with this.
  var refreshing=null;
  function refresh(){
    if(refreshing)return refreshing;
    // Fetch from the site root, not location.pathname: with Accept: application/json a /products/<handle>
    // URL answers with the product JSON (no sections), which left the drawer stale on every product page.
    var u=((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/')+'?sections='+SECTION;
    refreshing=Promise.all([
      nativeFetch(u,{headers:{'Accept':'application/json'},cache:'no-store'}).then(function(r){return r.json();}).catch(function(){return null;}),
      nativeFetch('/cart.js',{headers:{'Accept':'application/json'},cache:'no-store'}).then(function(r){return r.json();}).catch(function(){return null;})
    ]).then(function(res){
      if(res[0]&&res[0][SECTION])swap(res[0][SECTION]);
      if(res[1]&&typeof res[1].item_count==='number')setCount(res[1].item_count);
      document.dispatchEvent(new CustomEvent('kd:cart:updated',{detail:{cart:res[1]}}));
      return res[1];
    }).finally(function(){refreshing=null;});
    return refreshing;
  }
  function add(payload,openAfter){
    if(busy)return Promise.reject(new Error('busy'));busy=true;
    var body,json;
    if(payload instanceof FormData){body=payload;json=false;}
    else{body=JSON.stringify(payload);json=true;}
    document.dispatchEvent(new CustomEvent('kd:cart:adding',{detail:{source:'theme'}}));
    return post('/cart/add.js',body,json)
      .then(function(){return refresh();})
      .then(function(cart){if(openAfter!==false)open();return cart;})
      .finally(function(){busy=false;document.dispatchEvent(new CustomEvent('kd:cart:added',{detail:{source:'theme'}}));});
  }
  window.KDCart={add:add,change:change,open:open,close:close,refresh:refresh};

  // Apps (Globo Product Options) add the main product + linked add-ons with their own
  // /cart/add request. Watch for it so the theme can lock the ATC button while it runs and
  // re-sync the drawer/count once it has finished (never render from a half-done add).
  function isAdd(u,m){try{return String(m||'GET').toUpperCase()==='POST'&&/\/cart\/add(\.js|\.json)?(\?|$)/.test(new URL(String(u),location.href).pathname+'?');}catch(e){return false;}}
  function own(h){try{if(!h)return false;if(h instanceof Headers)return h.has(OWN);return !!(h[OWN]);}catch(e){return false;}}
  var appAdds=0;
  function appStart(){appAdds++;document.dispatchEvent(new CustomEvent('kd:cart:adding',{detail:{source:'app'}}));}
  function appEnd(ok){appAdds=Math.max(0,appAdds-1);var p=ok?refresh():Promise.resolve();p.finally(function(){document.dispatchEvent(new CustomEvent('kd:cart:added',{detail:{source:'app',ok:ok}}));});}
  window.fetch=function(input,init){
    var url=input&&input.url?input.url:input,method=(init&&init.method)||(input&&input.method);
    var headers=(init&&init.headers)||(input&&input.headers);
    var p=nativeFetch.apply(null,arguments);
    if(isAdd(url,method)&&!own(headers)){appStart();p.then(function(r){appEnd(r.ok);},function(){appEnd(false);});}
    return p;
  };
  var xo=XMLHttpRequest.prototype.open,xs=XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open=function(m,u){this.__kdAdd=isAdd(u,m);return xo.apply(this,arguments);};
  XMLHttpRequest.prototype.send=function(){
    if(this.__kdAdd){var x=this;appStart();x.addEventListener('loadend',function(){appEnd(x.status>=200&&x.status<300);});}
    return xs.apply(this,arguments);
  };
  document.addEventListener('gpoAddedToCart',function(){refresh();});
  // Back/forward cache can restore a page with a stale drawer/count.
  window.addEventListener('pageshow',function(e){if(e.persisted)refresh();});

  document.addEventListener('click',function(e){var o=e.target.closest('[data-cart-open]');if(o){e.preventDefault();open();}});
  ov.addEventListener('click',close);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  drawer.addEventListener('click',function(e){
    var t=e.target;
    if(t.closest('[data-cartclose]')){close();return;}
    if(t.closest('[data-qty-up]')){var it=t.closest('[data-key]');var sp=it.querySelector('.kd-dc-qty span');var q=parseInt(sp.textContent,10)||1;queueChange(it.getAttribute('data-key'),q+1,sp);return;}
    if(t.closest('[data-qty-down]')){var it2=t.closest('[data-key]');var sp2=it2.querySelector('.kd-dc-qty span');var q2=parseInt(sp2.textContent,10)||1;queueChange(it2.getAttribute('data-key'),Math.max(0,q2-1),sp2);return;}
    var addbtn=t.closest('[data-add]');
    if(addbtn){var vid=addbtn.getAttribute('data-add');if(vid){addbtn.setAttribute('disabled','');add({items:[{id:vid,quantity:1}]}).catch(function(){addbtn.removeAttribute('disabled');});}return;}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-cart"]) return;
  try {
    
(function(){
  var root=document.querySelector('[data-kd-cart]');
  if(!root)return;
  function money(cents){
    try{ return (window.Shopify&&Shopify.formatMoney)?Shopify.formatMoney(cents):('$'+(cents/100).toLocaleString(undefined,{minimumFractionDigits:0})); }
    catch(e){ return '$'+Math.round(cents/100); }
  }
  function busy(on){ root.style.opacity=on?'0.55':''; root.style.pointerEvents=on?'none':''; }
  function change(key,qty){
    busy(true);
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();})
      .then(function(){ window.location.reload(); })
      .catch(function(){ busy(false); });
  }
  root.querySelectorAll('[data-cart-item]').forEach(function(row){
    var key=row.getAttribute('data-key');
    var val=row.querySelector('[data-qty-val]');
    row.querySelector('[data-qty-down]').addEventListener('click',function(){ var q=parseInt(val.textContent,10)-1; change(key,q<0?0:q); });
    row.querySelector('[data-qty-up]').addEventListener('click',function(){ change(key,parseInt(val.textContent,10)+1); });
    row.querySelector('[data-cart-remove]').addEventListener('click',function(){ change(key,0); });
  });
  root.querySelectorAll('[data-up-add]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var id=btn.getAttribute('data-variant'); if(!id)return;
      busy(true);
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
        .then(function(r){return r.json();})
        .then(function(){ window.location.reload(); })
        .catch(function(){ busy(false); });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-commercial"] && !Shopify.designMode) return;
  try {
    
(function(){
  var track=document.querySelector('[data-cmc-track]'); if(!track)return;
  var viewport=track.parentElement;
  var prev=document.querySelector('[data-cmc-arrow="prev"]'),next=document.querySelector('[data-cmc-arrow="next"]');
  var dotswrap=document.querySelector('[data-cmc-dots]');
  var real=[].slice.call(track.children); var n=real.length;
  if(n>1){var fc=real[0].cloneNode(true),lc=real[n-1].cloneNode(true);fc.setAttribute('aria-hidden','true');lc.setAttribute('aria-hidden','true');track.appendChild(fc);track.insertBefore(lc,real[0]);}
  var idx=1, EASE='transform .5s cubic-bezier(.22,1,.36,1)';
  function place(anim){track.style.transition=anim?EASE:'none';track.style.transform='translateX('+(-idx*100)+'%)';if(!anim){track.offsetHeight;}}
  place(false);
  var dots=[];
  if(dotswrap){for(var d=0;d<n;d++){(function(k){var b=document.createElement('button');b.type='button';b.className='kd-cm-dot'+(k===0?' is-active':'');b.addEventListener('click',function(){idx=k+1;place(true);sync();});dotswrap.appendChild(b);})(d);}dots=[].slice.call(dotswrap.children);}
  function sync(){var r=((idx-1)%n+n)%n;dots.forEach(function(dt,i){dt.classList.toggle('is-active',i===r);});}
  track.addEventListener('transitionend',function(){if(idx===0){idx=n;place(false);}else if(idx===n+1){idx=1;place(false);}});
  if(prev)prev.addEventListener('click',function(){idx--;place(true);sync();});
  if(next)next.addEventListener('click',function(){idx++;place(true);sync();});
  sync();
  var x0=null;
  viewport.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
  viewport.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40){idx+=(dx<0?1:-1);place(true);sync();}x0=null;});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-faq"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.kd-faq [data-acc-toggle]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var acc=btn.closest('.kd-acc');var body=acc.querySelector('.kd-acc-body');
      var open=acc.classList.toggle('is-open');btn.setAttribute('aria-expanded',open?'true':'false');
      body.style.maxHeight=open?body.scrollHeight+'px':'0';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-furn"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.kd-furn').forEach(function(sec){
    var slots={cushion:sec.querySelector('[data-slot="cushion"]'),frame:sec.querySelector('[data-slot="frame"]')};
    sec.querySelectorAll('.kd-swatch').forEach(function(sw){
      sw.addEventListener('click',function(){
        var g=sw.getAttribute('data-group');
        sec.querySelectorAll('.kd-swatch[data-group="'+g+'"]').forEach(function(x){x.classList.remove('is-active');x.setAttribute('aria-pressed','false');});
        sw.classList.add('is-active');sw.setAttribute('aria-pressed','true');
        if(slots[g])slots[g].textContent=sw.getAttribute('data-name');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  var views=document.querySelector('[data-kd-galviews]');
  if(views){var vb=views.querySelectorAll('.kd-gal-view');
    function act(b,focus){vb.forEach(function(t){var on=t===b;t.classList.toggle('is-active',on);t.setAttribute('aria-selected',on);t.tabIndex=on?0:-1;var pn=document.getElementById(t.getAttribute('aria-controls'));if(pn)pn.hidden=!on;});if(focus)b.focus();}
    views.addEventListener('click',function(e){var b=e.target.closest('.kd-gal-view');if(b)act(b);});
    views.addEventListener('keydown',function(e){var a=[].slice.call(vb),i=a.indexOf(document.activeElement);if(i<0)return;if(e.key==='ArrowRight'){act(a[(i+1)%a.length],1);e.preventDefault();}if(e.key==='ArrowLeft'){act(a[(i-1+a.length)%a.length],1);e.preventDefault();}});
    if(location.hash==='#videos'){act(vb[1]);}
  }
  document.addEventListener('click',function(e){var b=e.target.closest('[data-kd-yt]');if(!b||b.querySelector('iframe'))return;
    var f=document.createElement('iframe');f.src='https://www.youtube-nocookie.com/embed/'+b.getAttribute('data-kd-yt')+'?autoplay=1&rel=0';f.title=b.getAttribute('data-title')||'YouTube video';f.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';f.allowFullscreen=true;b.innerHTML='';b.appendChild(f);});
})();
(function(){
  var tabs=document.querySelector('[data-kd-galtabs]');if(!tabs)return;
  var items=document.querySelectorAll('.kd-gal-item');
  tabs.addEventListener('click',function(e){
    var b=e.target.closest('.kd-gal-tab');if(!b)return;
    tabs.querySelectorAll('.kd-gal-tab').forEach(function(t){t.classList.remove('is-active');});
    tabs.querySelectorAll('.kd-gal-tab').forEach(function(t){t.setAttribute('aria-pressed','false');});b.classList.add('is-active');b.setAttribute('aria-pressed','true');
    var f=b.getAttribute('data-filter');
    items.forEach(function(it){it.classList.toggle('is-hidden', f!=='all' && it.getAttribute('data-cat')!==f);});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  var nav=document.getElementById('kdNav2'); if(!nav) return;
  function onScroll(){ nav.classList.toggle('is-scrolled', window.scrollY>20); }
  window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
  var items=nav.querySelectorAll('.kd-nav2-item[data-mega]');
  var panels=nav.querySelectorAll('.kd-mega[data-panel]');
  var t;
  function open(key){
    clearTimeout(t);
    items.forEach(function(it){var on=it.getAttribute('data-mega')===key;it.classList.toggle('is-active',on);var b=it.querySelector('.kd-nav2-link');if(b)b.setAttribute('aria-expanded',on?'true':'false');});
    panels.forEach(function(p){p.classList.toggle('is-shown',p.getAttribute('data-panel')===key);});
    nav.classList.add('is-mega-open');
  }
  function close(){
    items.forEach(function(it){it.classList.remove('is-active');var b=it.querySelector('.kd-nav2-link');if(b)b.setAttribute('aria-expanded','false');});
    panels.forEach(function(p){p.classList.remove('is-shown');});
    nav.classList.remove('is-mega-open');
  }
  items.forEach(function(it){
    var key=it.getAttribute('data-mega');
    it.addEventListener('mouseenter',function(){open(key);});
    it.addEventListener('mouseleave',function(){t=setTimeout(close,180);});
    var b=it.querySelector('.kd-nav2-link');
    if(b){b.addEventListener('focus',function(){open(key);});b.addEventListener('click',function(){ (it.classList.contains('is-active'))?close():open(key); });}
  });
  panels.forEach(function(p){
    p.addEventListener('mouseenter',function(){clearTimeout(t);});
    p.addEventListener('mouseleave',function(){t=setTimeout(close,180);});
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  var burger=nav.querySelector('.kd-nav2-burger');
  var drawer=document.getElementById('kdDrawer');
  var closeBtn=drawer&&drawer.querySelector('.kd-drawer-close');
  function openD(){if(drawer){drawer.classList.add('is-open');document.body.style.overflow='hidden';if(burger){burger.classList.add('is-open');burger.setAttribute('aria-expanded','true');}}}
  function closeD(){if(drawer){drawer.classList.remove('is-open');document.body.style.overflow='';if(burger){burger.classList.remove('is-open');burger.setAttribute('aria-expanded','false');}}}
  if(burger)burger.addEventListener('click',openD);
  if(closeBtn)closeBtn.addEventListener('click',closeD);
  if(drawer)drawer.querySelectorAll('.kd-drawer-toggle').forEach(function(tg){
    tg.addEventListener('click',function(e){
      e.stopPropagation();
      if(tg.classList.contains('kd-drawer-toggle--l2')){
        tg.closest('.kd-drawer-line').classList.toggle('is-open');
      } else {
        tg.closest('.kd-drawer-group').classList.toggle('is-open');
      }
    });
  });

  // Stations FreeFly panel: hover a line -> crossfade its station list
  nav.querySelectorAll('.kd-mega--stations').forEach(function(sm){
    var lines=sm.querySelectorAll('.kd-smega-line');
    var pans=sm.querySelectorAll('.kd-smega-panel');
    lines.forEach(function(ln){
      var idx=ln.getAttribute('data-sline');
      ln.addEventListener('mouseenter',function(){
        lines.forEach(function(l){ l.classList.toggle('is-active', l.getAttribute('data-sline')===idx); });
        pans.forEach(function(pp){ pp.classList.toggle('is-active', pp.getAttribute('data-spanel')===idx); });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-legal"]) return;
  try {
    
(function(){
  document.querySelectorAll('.kd-legal-sec').forEach(function(sec){
    var nav=sec.querySelector('[data-legal-nav]');
    var title=sec.querySelector('[data-legal-title]');
    var panels=sec.querySelectorAll('.kd-legal-panel');
    if(!nav)return;
    function slug(a){return (a.getAttribute('data-title')||'').toLowerCase().replace(/[^a-z0-9]+/g,'-');}
    function show(a){
      var t=a.getAttribute('data-target');
      nav.querySelectorAll('a[data-target]').forEach(function(x){x.classList.toggle('is-active',x===a);});
      panels.forEach(function(p){p.classList.toggle('is-hidden',p.getAttribute('data-panel')!==t);});
      if(title&&a.getAttribute('data-title'))title.textContent=a.getAttribute('data-title');
    }
    nav.querySelectorAll('a[data-target]').forEach(function(a){
      a.addEventListener('click',function(ev){
        ev.preventDefault();
        show(a);
        if(history.replaceState)history.replaceState(null,'','#'+slug(a));
        window.scrollTo({top:sec.offsetTop-80,behavior:'smooth'});
      });
    });
    /* Deep link: /pages/legal-stuff#privacy, #shipping, #terms-of-service, etc.
       Runs on load, pageshow and hashchange; always activates the panel matching location.hash and scrolls to it. */
    function hashSlug(){
      var h=location.hash||'';
      try{h=decodeURIComponent(h);}catch(e){}
      return h.replace(/^#/,'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
    }
    function match(){
      var h=hashSlug(),found=null;
      if(!h)return null;
      nav.querySelectorAll('a[data-target]').forEach(function(a){
        if(!found&&slug(a).replace(/^-+|-+$/g,'')===h)found=a;
      });
      return found;
    }
    function scrollToPanel(smooth){
      var a=sec.querySelector('[data-legal-nav] a.is-active');
      var p=a&&sec.querySelector('.kd-legal-panel[data-panel="'+a.getAttribute('data-target')+'"]');
      if(!p)return;
      window.scrollTo({top:Math.max(0,p.getBoundingClientRect().top+window.pageYOffset-80),behavior:smooth?'smooth':'auto'});
    }
    function apply(smooth){
      var a=match();
      if(!a)return false;
      show(a);
      scrollToPanel(smooth);
      return true;
    }
    if(apply(false)){
      /* Re-assert after layout settles (images/fonts) and over the browser's own scroll restoration. */
      window.addEventListener('load',function(){if(match())apply(false);});
    }
    window.addEventListener('hashchange',function(){apply(true);});
    window.addEventListener('pageshow',function(ev){if(ev.persisted)apply(false);});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-models"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.kd-models').forEach(function(sec){
    var track=sec.querySelector('.kd-models-track');
    var prev=sec.querySelector('[data-kd-arrow="prev"]');
    var next=sec.querySelector('[data-kd-arrow="next"]');
    if(!track)return;
    function step(){var c=track.querySelector('.kd-model-card');return (c?c.offsetWidth:320)+22;}
    function update(){
      if(prev)prev.disabled=track.scrollLeft<=4;
      if(next)next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-4;
    }
    if(prev)prev.addEventListener('click',function(){track.scrollBy({left:-step()*1.2,behavior:'smooth'});});
    if(next)next.addEventListener('click',function(){track.scrollBy({left:step()*1.2,behavior:'smooth'});});
    track.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update);
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-process"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.kd-process .kd-flow').forEach(function(flow){
    flow.classList.add('kd-anim');
    var steps=flow.querySelectorAll('.kd-flow-step');
    if(!('IntersectionObserver' in window)){flow.classList.add('is-in');steps.forEach(function(s){s.classList.add('is-in');});return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          flow.classList.add('is-in');
          steps.forEach(function(st,i){st.style.transitionDelay=(0.15+i*0.12)+'s';st.classList.add('is-in');});
          io.disconnect();
        }
      });
    },{threshold:0.25});
    io.observe(flow);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-kd-gallery]').forEach(function(g){
    var main=g.querySelector('[data-kd-gallery-main]');
    var viz=g.querySelector('[data-kd-viz-stage]');
    var vizNote=g.querySelector('[data-kd-pdp-viz-note]');
    var vizThumb=g.querySelector('[data-kd-thumb-viz]');
    function act(t){g.querySelectorAll('.kd-thumb').forEach(function(x){x.classList.remove('is-active');});if(t)t.classList.add('is-active');}
    if(vizThumb)vizThumb.addEventListener('click',function(){act(vizThumb);if(viz)viz.style.display='';if(vizNote)vizNote.style.display='';if(main)main.setAttribute('hidden','');});
    g.querySelectorAll('[data-kd-thumb]').forEach(function(t){
      t.addEventListener('click',function(){act(t);if(viz)viz.style.display='none';if(vizNote)vizNote.style.display='none';if(main){main.removeAttribute('hidden');main.src=t.getAttribute('data-kd-thumb');}});
    });
  });
  document.querySelectorAll('.kd-buy-accs [data-acc-toggle]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var acc=btn.closest('.kd-acc');var body=acc.querySelector('.kd-acc-body');
      var open=acc.classList.toggle('is-open');btn.setAttribute('aria-expanded',open?'true':'false');
      body.style.maxHeight=open?body.scrollHeight+'px':'0';
    });
  });
  // Variant selector (multi-variant, non-Globo products only): keeps hidden id, price and total in sync
  (function(){
    var box=document.querySelector('[data-kd-variants]');
    var idEl=document.querySelector('[data-kd-atc-form] [data-kd-variant-id]');
    var totalEl=document.querySelector('[data-kd-total]');
    var priceEl=document.querySelector('[data-kd-baseprice]');
    if(!box||!idEl)return;
    function apply(r,fromUser){
      idEl.value=r.value;
      if(totalEl)totalEl.setAttribute('data-kd-base',r.getAttribute('data-price'));
      if(priceEl)priceEl.textContent=r.getAttribute('data-price-formatted');
      if(fromUser&&window.history&&history.replaceState){try{var u=new URL(location.href);u.searchParams.set('variant',r.value);history.replaceState(null,'',u);}catch(e){}}
      document.dispatchEvent(new CustomEvent('kd:variant',{detail:{id:r.value}}));
    }
    box.addEventListener('change',function(e){if(e.target&&e.target.matches('input[type=radio]'))apply(e.target,true);});
    var cur=box.querySelector('input:checked');if(cur)apply(cur,false);
  })();
  // Quantity stepper (furniture): clamps 1 to 10 and re-prices the total
  (function(){
    var box=document.querySelector('[data-kd-qty]');
    if(!box)return;
    var input=box.querySelector('[data-kd-qty-input]');
    var minus=box.querySelector('[data-kd-qty-minus]');
    var plus=box.querySelector('[data-kd-qty-plus]');
    var MIN=1,MAX=10;
    function clamp(v){v=parseInt(v,10);if(isNaN(v)||v<MIN)v=MIN;if(v>MAX)v=MAX;return v;}
    function sync(fire){
      var v=clamp(input.value);
      if(String(v)!==input.value && document.activeElement!==input)input.value=v;
      minus.disabled=v<=MIN;plus.disabled=v>=MAX;
      if(fire)document.dispatchEvent(new CustomEvent('kd:qty',{detail:{qty:v}}));
    }
    function set(v){input.value=clamp(v);sync(true);}
    minus.addEventListener('click',function(){set(clamp(input.value)-1);});
    plus.addEventListener('click',function(){set(clamp(input.value)+1);});
    input.addEventListener('input',function(){
      // allow an empty field while typing; price as 1 until a number is entered
      sync(true);
    });
    input.addEventListener('change',function(){set(input.value);});
    input.addEventListener('blur',function(){set(input.value);});
    input.addEventListener('keydown',function(e){if(e.key==='Enter'){set(input.value);}});
    // Never let a stray scroll wheel change the quantity
    input.addEventListener('wheel',function(){input.blur();},{passive:true});
    // Make sure the value in the form is valid right before any add (ours or Globo's)
    window.addEventListener('submit',function(){set(input.value);},true);
    window.addEventListener('click',function(e){if(e.target&&e.target.closest&&e.target.closest('[data-kd-atc]'))set(input.value);},true);
    window.addEventListener('pageshow',function(){set(input.value);});
    sync(false);
  })();
  // live "Your build" total from Globo add-ons (data-addon-price)
  (function(){
    var slot=document.querySelector('.kd-globo-slot');
    var totalEl=document.querySelector('[data-kd-total]');
    if(!slot||!totalEl)return;
    function fmt(c){return '$'+Math.round(c/100).toLocaleString('en-US');}
    function recalc(){
      var base=parseInt(totalEl.getAttribute('data-kd-base')||'0',10);
      // Count each selected option value exactly once. Globo repeats the "(+ $X)" .addOn
      // inside a label (title + hidden tooltip), so read only the first one per selection.
      var addon=0, seen={};
      function num(t){var n=parseFloat((t||'').replace(/[^0-9.\-]/g,''));return isNaN(n)?null:n;}
      function add(key,el,lab){
        if(seen[key])return;seen[key]=1;
        var a=lab&&lab.querySelector('.addOn'), n=a?num(a.textContent):null;
        if(n===null){n=parseFloat(el.getAttribute('data-addon-price'));if(isNaN(n))n=null;}
        if(n!==null)addon+=n;
      }
      slot.querySelectorAll('input:checked').forEach(function(i){
        var lab=(i.nextElementSibling&&i.nextElementSibling.tagName==='LABEL')?i.nextElementSibling:(i.id?slot.querySelector('label[for="'+CSS.escape(i.id)+'"]'):null);
        add('i|'+(i.name||i.id)+'|'+i.value,i,lab);
      });
      slot.querySelectorAll('select').forEach(function(s){
        Array.prototype.forEach.call(s.selectedOptions||[],function(o){add('s|'+s.name+'|'+o.value,o,o);});
      });
      var unit=base+Math.round(addon*100);
      var qtyEl=document.querySelector('[data-kd-qty-input]');
      var q=qtyEl?parseInt(qtyEl.value,10):1;if(isNaN(q)||q<1)q=1;if(q>10)q=10;
      totalEl.textContent=fmt(unit*q);
      var each=document.querySelector('[data-kd-total-each]');
      if(each){if(q>1){each.textContent=q+' \u00d7 '+fmt(unit)+' each';each.hidden=false;}else{each.textContent='';each.hidden=true;}}
    }
    slot.addEventListener('change',recalc);
    document.addEventListener('kd:variant',recalc);
    document.addEventListener('kd:qty',recalc);
    var mo=new MutationObserver(function(){recalc();});
    mo.observe(slot,{subtree:true,childList:true});
    var n=0,iv=setInterval(function(){n++;if(slot.querySelector('input,select')||n>40){recalc();clearInterval(iv);}},150);
  })();
  // "See examples" links + card-strip lightbox with image zoom
  (function(){
    var dataEl=document.querySelector('[data-kd-examples]');
    var box=document.querySelector('[data-kd-ex-lightbox]');
    var slot=document.querySelector('.kd-globo-slot');
    if(!dataEl||!box||!slot)return;
    var items=[];try{items=JSON.parse(dataEl.textContent);}catch(e){return;}
    var intros={};var introEl=document.querySelector('[data-kd-ex-intros]');if(introEl){try{intros=JSON.parse(introEl.textContent);}catch(e){}}
    var refs={};var refEl=document.querySelector('[data-kd-references]');if(refEl){try{refs=JSON.parse(refEl.textContent);}catch(e){}}
    if(!items.length && !Object.keys(intros).length && !Object.keys(refs).length)return;
    var groups={};items.forEach(function(it){(groups[it.group]=groups[it.group]||[]).push(it);});
    function handleize(s){return (s||'').toLowerCase().trim().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');}
    function esc(s){return (s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}

    var headEl=box.querySelector('[data-ex-heading]'),blurbEl=box.querySelector('[data-ex-blurb]'),ruleEl=box.querySelector('.kd-ex-rule');
    var stripEl=box.querySelector('[data-ex-strip]');
    var zoom=box.querySelector('[data-ex-zoom]'),zImg=box.querySelector('[data-zoom-img]'),zCap=box.querySelector('[data-zoom-cap]');
    var curImgs=[],zIdx=0;

    var refWrap=box.querySelector('[data-ex-refwrap]');
    var refImg=box.querySelector('[data-ex-refimg]');
    var refBtn=box.querySelector('[data-ex-refbtn]');
    function openPopup(g){
      var ref=refs[g];
      if(ref){
        var rh=!!ref.heading, rb=!!ref.blurb;
        headEl.textContent=ref.heading||''; headEl.style.display=rh?'block':'none';
        blurbEl.innerHTML=ref.blurb||''; blurbEl.style.display=rb?'block':'none';
        if(ruleEl)ruleEl.style.display=rh?'block':'none';
        stripEl.style.display='none'; refWrap.style.display='block';
        curImgs=[{src:ref.src,cap:ref.heading||''}];
        refImg.src=ref.src||''; refImg.alt=ref.heading||refImg.alt||'';
        box.classList.add('is-open'); box.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden';
        return;
      }
      refWrap.style.display='none'; stripEl.style.display='flex';
      var cur=groups[g]||[]; var info=intros[g]||{};
      var hasHead=!!info.heading, hasBlurb=!!info.blurb;
      headEl.textContent=info.heading||''; headEl.style.display=hasHead?'block':'none';
      blurbEl.innerHTML=info.blurb||''; blurbEl.style.display=hasBlurb?'block':'none';
      if(ruleEl)ruleEl.style.display=hasHead?'block':'none';
      stripEl.innerHTML=''; curImgs=[];
      var HINT='<span class="kd-ex-zoom-hint"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3M11 8v6M8 11h6"/></svg></span>';
      var ARR_L='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
      var ARR_R='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';
      cur.forEach(function(it){
        var card=document.createElement('div');card.className='kd-ex-card';
        var imgs=[]; if(it.src)imgs.push(it.src); if(it.src2)imgs.push(it.src2);
        var media;
        if(imgs.length){
          var multi=imgs.length>1, slidesHtml='';
          var alt=esc(it.label||it.caption||'');
          imgs.forEach(function(src){
            var gi=curImgs.length; curImgs.push({src:src,cap:(it.label||it.caption||'')});
            slidesHtml+='<button class="kd-ex-card-slide" type="button" data-zoom-open="'+gi+'"><img src="'+esc(src)+'" alt="'+alt+'"></button>';
          });
          media='<div class="kd-ex-card-media'+(multi?' is-multi':'')+'">'
            +'<div class="kd-ex-card-track">'+slidesHtml+'</div>'
            +(it.tag?'<span class="kd-ex-card-tag">'+esc(it.tag)+'</span>':'')
            +(multi?('<button class="kd-ex-card-nav kd-ex-card-prev" type="button" aria-label="Previous">'+ARR_L+'</button><button class="kd-ex-card-nav kd-ex-card-next" type="button" aria-label="Next">'+ARR_R+'</button><div class="kd-ex-card-dots"></div>'):'')
            +HINT
            +'</div>';
        } else { media='<span class="kd-ex-card-media is-placeholder"></span>'; }
        var body='<div class="kd-ex-card-body">'
          +(it.label?'<h4 class="kd-ex-card-label">'+esc(it.label)+'</h4>':'')
          +(it.caption?'<p class="kd-ex-card-desc">'+esc(it.caption)+'</p>':'')
          +'</div>';
        card.innerHTML=media+body;
        stripEl.appendChild(card);
      });
      stripEl.querySelectorAll('.kd-ex-card-slide[data-zoom-open]').forEach(function(btn){
        btn.addEventListener('click',function(){openZoom(parseInt(btn.getAttribute('data-zoom-open'),10));});
      });
      stripEl.querySelectorAll('.kd-ex-card-media.is-multi').forEach(function(m){
        var track=m.querySelector('.kd-ex-card-track');
        var slides=m.querySelectorAll('.kd-ex-card-slide');
        var dotsWrap=m.querySelector('.kd-ex-card-dots');
        var nn=slides.length, ii=0;
        for(var d=0;d<nn;d++){var b=document.createElement('button');b.type='button';b.className='kd-ex-card-dot'+(d===0?' is-active':'');(function(idx){b.addEventListener('click',function(e){e.stopPropagation();mgo(idx);});})(d);dotsWrap.appendChild(b);}
        var dots=dotsWrap.querySelectorAll('.kd-ex-card-dot');
        function mgo(k){ii=(k+nn)%nn;track.style.transform='translateX('+(-ii*100)+'%)';dots.forEach(function(x,z){x.classList.toggle('is-active',z===ii);});}
        m.querySelector('.kd-ex-card-prev').addEventListener('click',function(e){e.stopPropagation();mgo(ii-1);});
        m.querySelector('.kd-ex-card-next').addEventListener('click',function(e){e.stopPropagation();mgo(ii+1);});
      });
      box.classList.add('is-open');box.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';stripEl.scrollLeft=0;
    }
    function closePopup(){box.classList.remove('is-open');box.setAttribute('aria-hidden','true');document.body.style.overflow='';closeZoom();}

    function showZoom(i){if(!curImgs.length)return;zIdx=(i+curImgs.length)%curImgs.length;zImg.src=curImgs[zIdx].src;zImg.alt=curImgs[zIdx].cap||zImg.alt||'';zCap.textContent=curImgs[zIdx].cap||'';}
    function openZoom(i){showZoom(i);zoom.classList.add('is-open');zoom.setAttribute('aria-hidden','false');}
    function closeZoom(){zoom.classList.remove('is-open');zoom.setAttribute('aria-hidden','true');}

    box.querySelectorAll('[data-ex-close]').forEach(function(b){b.addEventListener('click',closePopup);});
    if(refBtn)refBtn.addEventListener('click',function(){openZoom(0);});
    box.querySelector('[data-zoom-close]').addEventListener('click',function(e){e.stopPropagation();closeZoom();});
    box.querySelector('[data-zoom-prev]').addEventListener('click',function(e){e.stopPropagation();showZoom(zIdx-1);});
    box.querySelector('[data-zoom-next]').addEventListener('click',function(e){e.stopPropagation();showZoom(zIdx+1);});
    zoom.addEventListener('click',function(e){if(e.target===zoom)closeZoom();});
    // swipe on zoom (mobile)
    var zx0=null;
    zoom.addEventListener('touchstart',function(e){zx0=e.touches[0].clientX;},{passive:true});
    zoom.addEventListener('touchend',function(e){if(zx0===null)return;var dx=e.changedTouches[0].clientX-zx0;if(Math.abs(dx)>34){showZoom(dx<0?zIdx+1:zIdx-1);}zx0=null;});
    document.addEventListener('keydown',function(e){
      if(!box.classList.contains('is-open'))return;
      if(zoom.classList.contains('is-open')){if(e.key==='Escape')closeZoom();if(e.key==='ArrowLeft')showZoom(zIdx-1);if(e.key==='ArrowRight')showZoom(zIdx+1);}
      else if(e.key==='Escape')closePopup();
    });

    function inject(){
      slot.querySelectorAll('.gpo-label').forEach(function(lbl){
        if(lbl.querySelector('.kd-config-ex'))return;
        var lc=lbl.querySelector('.label-content');var name=(lc?lc.textContent:lbl.textContent);
        var g=handleize(name);
        var hasItems=groups[g]&&groups[g].length;
        var hasIntro=intros[g]&&(intros[g].heading||intros[g].blurb||intros[g].label);
        var hasRef=refs[g]&&refs[g].src;
        if(hasItems||hasIntro||hasRef){
          var a=document.createElement('button');a.type='button';a.className='kd-config-ex';
          a.textContent=(refs[g]&&refs[g].trigger)?refs[g].trigger:((intros[g]&&intros[g].label)?intros[g].label:'See examples');
          a.addEventListener('click',function(ev){ev.preventDefault();openPopup(g);});
          lbl.appendChild(a);
        }
      });
    }
    var mo=new MutationObserver(inject);mo.observe(slot,{subtree:true,childList:true});
    var n=0,iv=setInterval(function(){n++;inject();if(slot.querySelector('.gpo-label')||n>40)clearInterval(iv);},150);
  })();
  // ---- Furniture visualizer: inline SVG in gallery + recolor live from Globo ----
  (function(){
    var stage=document.querySelector('[data-kd-viz-stage]');
    var slot=document.querySelector('.kd-globo-slot');
    if(!stage||!slot)return;
    var FRAME={'clear coating':'#AEB6BC','clear coat':'#AEB6BC','clear coat (aluminum)':'#AEB6BC','aluminum':'#AEB6BC','dark bronze':'#4A4033','white':'#ECECEC','black':'#262626'};
    var CUSHION={'alloy':'#B5B5AC','denim':'#7A8190','fennel':'#99886D','gravel':'#7B705E','oasis':'#578083','oyster':'#CFCABA','pebble':'#CCC3A8','pewter':'#78736D','shadow':'#4E4A46'};
    function setV(k,v){if(v)stage.style.setProperty(k,v);}
    // Table Top Color -> Middle_box insert (Ottoman only: needs a Middle_box group in the SVG + a Table Top Color option)
    var insLast='',insReady=false;
    function insSetup(){
      if(insReady)return true;
      var svg=stage.querySelector('svg');var mb=svg&&svg.querySelector('#Middle_box');
      if(!mb)return false;
      var tops=mb.querySelectorAll('.cls-46,.cls-47,.cls-27,.cls-26');
      var walls=mb.querySelectorAll('.cls-36');
      var holes=mb.querySelectorAll('g[class] > .cls-51');
      if(!tops.length)return false;
      var NS='http://www.w3.org/2000/svg';
      var defs=svg.querySelector('defs');if(!defs){defs=document.createElementNS(NS,'defs');svg.insertBefore(defs,svg.firstChild);}
      var pat=document.createElementNS(NS,'pattern');
      pat.setAttribute('id','kd-insert-pat');pat.setAttribute('patternUnits','userSpaceOnUse');pat.setAttribute('width','70');pat.setAttribute('height','70');
      pat.innerHTML='<rect width="70" height="70" style="fill:var(--insert,#d8d6cf)"/><image id="kd-insert-img" x="-11" y="-11" width="92" height="92" preserveAspectRatio="xMidYMid slice"/>';
      defs.appendChild(pat);
      // end piece (front end face) pattern: same swatch, grain skewed along the face plane
      var patF=pat.cloneNode(true);patF.setAttribute('id','kd-insert-pat-face');patF.setAttribute('patternTransform','matrix(1 -0.24 0 1 0 0)');
      var fi=patF.querySelector('image');if(fi)fi.setAttribute('id','kd-insert-img-face');
      defs.appendChild(patF);
      mb.querySelectorAll('polygon.cls-51').forEach(function(e){e.setAttribute('data-kd-ins','face');});
      mb.querySelectorAll('polygon.cls-41').forEach(function(e){e.setAttribute('data-kd-ins','side');});
      mb.querySelectorAll('path.cls-41').forEach(function(e){e.setAttribute('data-kd-ins','panel');});
      mb.querySelectorAll('path.cls-48').forEach(function(e){e.setAttribute('data-kd-ins','edge');});
      tops.forEach(function(e){e.setAttribute('data-kd-ins','top');});
      walls.forEach(function(e){e.setAttribute('data-kd-ins','wall');});
      holes.forEach(function(e){e.setAttribute('data-kd-ins','hole');});
      insReady=true;return true;
    }
    function insApply(src){
      if(!src||src===insLast||!insSetup())return;
      insLast=src;
      var url=src.split('?')[0];
      var img=stage.querySelector('#kd-insert-img');
      if(img){img.setAttribute('href',url);img.setAttributeNS('http://www.w3.org/1999/xlink','href',url);}
      var imgF=stage.querySelector('#kd-insert-img-face');
      if(imgF){imgF.setAttribute('href',url);imgF.setAttributeNS('http://www.w3.org/1999/xlink','href',url);}
      stage.setAttribute('data-kd-insert','1');
      // flat average colour as backdrop/fallback (needs CORS; Shopify CDN sends it)
      try{
        var im=new Image();im.crossOrigin='anonymous';
        im.onload=function(){try{
          var c=document.createElement('canvas');c.width=c.height=16;var x=c.getContext('2d');
          var w=im.naturalWidth,h=im.naturalHeight,m=Math.round(w*0.2);
          x.drawImage(im,m,m,w-2*m,h-2*m,0,0,16,16);var d=x.getImageData(0,0,16,16).data,r=0,g=0,b=0,n=0;
          for(var i=0;i<d.length;i+=4){if(d[i+3]>200){r+=d[i];g+=d[i+1];b+=d[i+2];n++;}}
          if(n&&insLast===src)setV('--insert','rgb('+Math.round(r/n)+','+Math.round(g/n)+','+Math.round(b/n)+')');
        }catch(e){}};
        im.src=url;
      }catch(e){}
    }
    function nameOf(el){var lc=el.querySelector('.gpo-label .label-content');return (lc?lc.textContent:'').trim().toLowerCase();}
    function readColors(){
      slot.querySelectorAll('.gpo-element').forEach(function(el){
        var nm=nameOf(el);
        if(nm.indexOf('cushion')>-1||nm.indexOf('canvas')>-1||nm.indexOf('fabric')>-1){
          var chk=el.querySelector('.color-swatches input:checked');
          if(chk){
            var lab=chk.nextElementSibling;var top=lab&&lab.querySelector('.swatch-top');
            var col=top?getComputedStyle(top).backgroundColor:'';
            if(col&&col!=='rgba(0, 0, 0, 0)'&&col!=='transparent'){setV('--cushion',col);return;}
            var val=(chk.value||'').toLowerCase();var tip=lab&&lab.querySelector('.gpo-tooltip');var tname=tip?tip.textContent.trim().toLowerCase():'';
            if(CUSHION[val])setV('--cushion',CUSHION[val]);else if(CUSHION[tname])setV('--cushion',CUSHION[tname]);
          }
        } else if(nm.indexOf('table top')>-1){
          var tchk=el.querySelector('input:checked');
          if(tchk){
            var tlab=tchk.nextElementSibling;var timg=tlab&&tlab.querySelector('img');
            if(timg)insApply(timg.currentSrc||timg.src);
          }
        } else if(nm.indexOf('frame')>-1){
          var fchk=el.querySelector('.color-swatches input:checked');
          if(fchk){
            var flab=fchk.nextElementSibling;var ftop=flab&&flab.querySelector('.swatch-top');
            var fcol=ftop?getComputedStyle(ftop).backgroundColor:'';
            if(fcol&&fcol!=='rgba(0, 0, 0, 0)'&&fcol!=='transparent'){setV('--frame',fcol);return;}
            var fval=(fchk.value||'').toLowerCase();var ftip=flab&&flab.querySelector('.gpo-tooltip');var ftname=ftip?ftip.textContent.trim().toLowerCase():'';
            if(FRAME[fval])setV('--frame',FRAME[fval]);else if(FRAME[ftname])setV('--frame',FRAME[ftname]);
            return;
          }
          var v=el.querySelector('.dropdown-button__value');var txt=v?v.textContent.trim().toLowerCase():'';
          if(!txt){var sel=el.querySelector('select');if(sel&&sel.value)txt=sel.value.trim().toLowerCase();}
          if(FRAME[txt])setV('--frame',FRAME[txt]);
        }
      });
    }
    var url=stage.getAttribute('data-svg-url');
    if(url){
      fetch(url).then(function(r){return r.text();}).then(function(svg){
        var sk=stage.querySelector('[data-kd-viz-skeleton]');
        stage.insertAdjacentHTML('beforeend',svg);
        if(sk)sk.remove();
        var el=stage.querySelector('svg');if(el){el.removeAttribute('width');el.removeAttribute('height');el.style.width='100%';el.style.height='auto';}
        readColors();
      }).catch(function(){var sk=stage.querySelector('[data-kd-viz-skeleton]');if(sk)sk.innerHTML='<span style="border:none;width:auto;height:auto;color:var(--kd-slate);font:600 12px var(--kd-font-body)">Preview unavailable</span>';});
    }
    slot.addEventListener('change',readColors);
    var mo=new MutationObserver(function(){readColors();});mo.observe(slot,{subtree:true,childList:true,attributes:true,attributeFilter:['class','style']});
    var n=0,iv=setInterval(function(){n++;readColors();if(n>50)clearInterval(iv);},200);
  })();
})();
  // ---- Gallery image lightbox (real images only; visualizer slide is never hijacked) ----
  (function(){
    var g=document.querySelector('[data-kd-gallery]');
    var lb=document.querySelector('[data-kd-lb]');
    var main=g&&g.querySelector('[data-kd-gallery-main]');
    if(!g||!lb||!main)return;
    var items=[];
    try{items=JSON.parse(lb.querySelector('[data-kd-lb-data]').textContent)||[];}catch(e){}
    if(!items.length)return;
    document.body.appendChild(lb);
    var stage=lb.querySelector('[data-kd-lb-stage]'),img=lb.querySelector('[data-kd-lb-img]'),count=lb.querySelector('[data-kd-lb-count]'),thumbsEl=lb.querySelector('[data-kd-lb-thumbs]');
    var cur=0,curMain=0,opener=null,isOpen=false,prevOverflow='',prevPad='';
    if(items.length<2)lb.setAttribute('data-single','');
    var tb=items.map(function(it,i){var b=document.createElement('button');b.type='button';b.className='kd-lb-thumb';b.setAttribute('aria-label','View image '+(i+1));b.style.backgroundImage='url('+it.thumb+')';b.addEventListener('click',function(){show(i);});thumbsEl.appendChild(b);return b;});
    // Track which image the main stage is showing (thumb clicks swap it)
    g.querySelectorAll('[data-kd-thumb]').forEach(function(t,i){t.addEventListener('click',function(){curMain=i;});});
    for(var k=0;k<items.length;k++){if(items[k].src&&main.getAttribute('src')&&main.getAttribute('src').split('?')[0]===items[k].src.split('?')[0]){curMain=k;break;}}
    main.setAttribute('role','button');main.setAttribute('tabindex','0');
    main.setAttribute('aria-label','View larger image: '+(main.getAttribute('alt')||'product image'));
    function syncMain(){var h=main.hasAttribute('hidden');main.setAttribute('tabindex',h?'-1':'0');if(h)main.setAttribute('aria-hidden','true');else main.removeAttribute('aria-hidden');}
    syncMain();if(window.MutationObserver)new MutationObserver(syncMain).observe(main,{attributes:true,attributeFilter:['hidden']});
    function zoomed(){return stage.classList.contains('is-zoomed');}
    function unzoom(){stage.classList.remove('is-zoomed');}
    function updZoomable(){img.classList.toggle('can-zoom',img.naturalWidth>img.clientWidth+24);}
    function show(i){
      cur=(i+items.length)%items.length;unzoom();
      img.classList.remove('is-ready','can-zoom');
      img.onload=function(){img.classList.add('is-ready');updZoomable();};
      img.alt=items[cur].alt||img.alt||'';img.src=items[cur].src;
      if(img.complete&&img.naturalWidth){img.onload();}
      count.textContent=(cur+1)+' / '+items.length;
      tb.forEach(function(b,j){if(j===cur)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current');});
      var a=tb[cur];if(a&&a.scrollIntoView&&thumbsEl.scrollWidth>thumbsEl.clientWidth){thumbsEl.scrollLeft=a.offsetLeft-(thumbsEl.clientWidth-a.offsetWidth)/2;}
      [cur+1,cur-1].forEach(function(n){var it=items[(n+items.length)%items.length];if(it){var p=new Image();p.src=it.src;}});
    }
    function open(i){
      if(isOpen)return;
      opener=document.activeElement&&document.activeElement!==document.body?document.activeElement:main;
      isOpen=true;lb.hidden=false;
      var sw=window.innerWidth-document.documentElement.clientWidth;
      prevOverflow=document.body.style.overflow;prevPad=document.body.style.paddingRight;
      document.body.style.overflow='hidden';if(sw>0)document.body.style.paddingRight=sw+'px';
      show(i);
      lb.querySelector('[data-kd-lb-close]').focus();
    }
    function close(){
      if(!isOpen)return;
      isOpen=false;lb.hidden=true;unzoom();
      document.body.style.overflow=prevOverflow;document.body.style.paddingRight=prevPad;
      var o=opener;opener=null;if(o&&document.contains(o)&&o.offsetParent!==null){o.focus();}else{main.focus();}
    }
    main.addEventListener('click',function(){if(!main.hasAttribute('hidden'))open(curMain);});
    main.addEventListener('keydown',function(e){if((e.key==='Enter'||e.key===' ')&&!main.hasAttribute('hidden')){e.preventDefault();open(curMain);}});
    lb.querySelector('[data-kd-lb-close]').addEventListener('click',close);
    lb.querySelector('[data-kd-lb-prev]').addEventListener('click',function(){show(cur-1);});
    lb.querySelector('[data-kd-lb-next]').addEventListener('click',function(){show(cur+1);});
    // Click on the overlay / empty stage area closes; click on the image toggles zoom
    lb.addEventListener('click',function(e){
      if(e.target===lb||e.target===stage||e.target===thumbsEl){close();return;}
      if(e.target===img&&(img.classList.contains('can-zoom')||zoomed())){stage.classList.toggle('is-zoomed');if(zoomed()){stage.scrollLeft=(stage.scrollWidth-stage.clientWidth)/2;stage.scrollTop=0;}}
    });
    document.addEventListener('keydown',function(e){
      if(!isOpen)return;
      if(e.key==='Escape'){e.preventDefault();e.stopPropagation();close();}
      else if(e.key==='ArrowRight'&&items.length>1){e.preventDefault();show(cur+1);}
      else if(e.key==='ArrowLeft'&&items.length>1){e.preventDefault();show(cur-1);}
      else if(e.key==='Tab'){
        var f=Array.prototype.filter.call(lb.querySelectorAll('button'),function(b){return b.offsetParent!==null;});
        if(!f.length)return;
        var first=f[0],last=f[f.length-1],a=document.activeElement;
        if(!lb.contains(a)){e.preventDefault();first.focus();}
        else if(e.shiftKey&&a===first){e.preventDefault();last.focus();}
        else if(!e.shiftKey&&a===last){e.preventDefault();first.focus();}
      }
    },true);
    // Swipe on touch
    var sx=0,sy=0,tracking=false;
    stage.addEventListener('touchstart',function(e){if(zoomed()||e.touches.length!==1){tracking=false;return;}tracking=true;sx=e.touches[0].clientX;sy=e.touches[0].clientY;},{passive:true});
    stage.addEventListener('touchend',function(e){
      if(!tracking||items.length<2)return;tracking=false;
      var t=e.changedTouches[0],dx=t.clientX-sx,dy=t.clientY-sy;
      if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5){show(dx<0?cur+1:cur-1);}
    },{passive:true});
    window.addEventListener('resize',function(){if(isOpen)updZoomable();});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-proof"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.kd-proof-reels').forEach(function(reels){
    var tabs=reels.querySelectorAll('[data-kd-reel-tab]');
    var vids=reels.querySelectorAll('[data-kd-reel-video]');
    var fills=reels.querySelectorAll('.kd-proof-tab-fill');
    var mute=reels.querySelector('[data-kd-mute]');
    var cur=0,started=false;
    function show(i){
      started=true;
      tabs.forEach(function(t,n){t.classList.toggle('is-active',n===i);});
      vids.forEach(function(v,n){
        v.classList.toggle('is-active',n===i);
        if(n===i){try{v.currentTime=0;var p=v.play();if(p)p.catch(function(){});}catch(e){}}
        else{v.pause();}
      });
      fills.forEach(function(f){f.style.transform='scaleX(0)';});
      cur=i;
    }
    tabs.forEach(function(t,i){t.addEventListener('click',function(){show(i);});});
    vids.forEach(function(v,i){
      v.addEventListener('timeupdate',function(){
        if(i!==cur||!fills[i])return;
        var pct=v.duration?v.currentTime/v.duration:0;
        fills[i].style.transform='scaleX('+pct+')';
      });
      v.addEventListener('ended',function(){show((cur+1)%vids.length);});
    });
    if(mute){mute.addEventListener('click',function(){
      var on=mute.classList.toggle('is-on');
      vids.forEach(function(v){v.muted=!on;});
    });}
    /* Defer loading/playing until the reel nears the viewport so it doesn't compete with the hero video. */
    function start(){if(!started)show(cur);}
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){if(e.isIntersecting){io.disconnect();start();}});
      },{rootMargin:'200px 0px'});
      io.observe(reels);
    }else if(document.readyState==='complete'){start();}
    else{window.addEventListener('load',start);}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-reveal"] && !Shopify.designMode) return;
  try {
    
(function(){
  var sec=document.currentScript&&document.currentScript.closest?document.currentScript.closest('.kd-reveal'):document.querySelector('.kd-reveal');
  var all=document.querySelectorAll('.kd-reveal');
  all.forEach(function(el){
    if(!('IntersectionObserver' in window)){el.classList.add('is-lit');return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-lit'); io.unobserve(e.target); } });
    },{threshold:.4});
    io.observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-seo"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.kd-seosec [data-acc-toggle]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var acc=btn.closest('.kd-acc');
      var body=acc.querySelector('.kd-acc-body');
      var open=acc.classList.toggle('is-open');
      btn.setAttribute('aria-expanded',open?'true':'false');
      body.style.maxHeight=open?body.scrollHeight+'px':'0';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-visualizer"] && !Shopify.designMode) return;
  try {
    
(function(){
  var FRAMES=[["Clear coat (aluminum)","#AEB6BC"],["Dark bronze","#4A4033"],["White","#ECECEC"],["Black","#262626"]];
  var CUSHIONS=[["Alloy","#B5B5AC"],["Denim","#7A8190"],["Fennel","#99886D"],["Gravel","#7B705E"],["Oasis","#578083"],["Oyster","#CFCABA"],["Pebble","#CCC3A8"],["Pewter","#78736D"],["Shadow","#4E4A46"]];
  document.querySelectorAll('.kd-viz-section').forEach(function(section){
    var stage=section.querySelector('[data-viz-stage]'); if(!stage) return;
    function build(list,wrap,nameEl,varName){
      var cur=getComputedStyle(section).getPropertyValue(varName).trim().toLowerCase();
      var si=0; list.forEach(function(c,i){ if(c[1].toLowerCase()===cur) si=i; });
      list.forEach(function(c,i){
        var b=document.createElement('button');
        b.className='kd-viz-sw'+(i===si?' is-active':''); b.type='button'; b.style.background=c[1]; b.title=c[0]; b.setAttribute('aria-label',c[0]);
        b.addEventListener('click',function(){
          section.style.setProperty(varName,c[1]); if(nameEl) nameEl.textContent=c[0];
          wrap.querySelectorAll('.kd-viz-sw').forEach(function(x){x.classList.remove('is-active');}); b.classList.add('is-active');
        });
        wrap.appendChild(b);
      });
      if(nameEl && list[si]) nameEl.textContent=list[si][0];
    }
    build(FRAMES,section.querySelector('[data-frame-swatches]'),section.querySelector('[data-frame-name]'),'--frame');
    build(CUSHIONS,section.querySelector('[data-cushion-swatches]'),section.querySelector('[data-cushion-name]'),'--cushion');
    var url=stage.getAttribute('data-svg-url'); if(!url) return;
    fetch(url).then(function(r){return r.text();}).then(function(svg){
      stage.innerHTML=svg;
      var el=stage.querySelector('svg'); if(el){ el.removeAttribute('width'); el.removeAttribute('height'); el.style.width='100%'; el.style.height='auto'; }
    }).catch(function(){
      var sk=stage.querySelector('[data-viz-skeleton]'); if(sk){ sk.innerHTML='<span style="border:none;width:auto;height:auto;color:var(--kd-slate);font:600 13px var(--kd-font-body)">Preview unavailable</span>'; }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
